import { Component, OnInit } from '@angular/core';
import { IffShipmentSummaryService } from 'src/app/services/iff-shipment-summary/iff-shipment-summary.service';
import { Router } from '@angular/router';
import { IFFShipmentSummaryResponse } from 'src/app/shared/common-components/common-structure';
import { IffShipmentDetailsService } from 'src/app/services/iff-shipment-details/iff-shipment-details.service';
import { ColDef, ColGroupDef } from 'ag-grid-community';
import {CommonHelpers} from "../../../shared/common-helpers";
import { map } from 'rxjs';

@Component({
    selector: 'app-frt-iff-summary',
    templateUrl: './frt-iff-summary.component.html',
    styleUrls: ['./frt-iff-summary.component.css'],
    standalone: false
})
export class FrtIffSummaryComponent implements OnInit {

  constructor(private iffShipmentSummaryService: IffShipmentSummaryService,  private iffShipmentDetailsService: IffShipmentDetailsService,
    private router: Router) { }

  updateFRTShipmentPaginationRequestFn = this.iffShipmentSummaryService.updateFRTShipmentPaginationRequest;
  FRTShipmentPaginationResults$ = this.iffShipmentSummaryService.FRTShipmentResults$.pipe(
    map((t: any) => {
      if (t && t.content) {
        return CommonHelpers.sortAtoZ(t.content);
      }
      return [];
    })
  );
  updateFRTIffShipmentDetailRequestFn = this.iffShipmentDetailsService.updateFRTIffShipmentDetailRequestFn;
  frtIFFShipmentDetailResults$ = this.iffShipmentDetailsService.frtIFFShipmentDetailResult$;
  ngOnInit() {
  }

  OnFRTShipmentSelected(IFFShipmentSelected: IFFShipmentSummaryResponse) {
    this.iffShipmentSummaryService.updateSelectedFRTShipmentSummary(IFFShipmentSelected);
    this.router.navigate(['/', 'frtIffDetail'],
    { queryParams: { iffMasterId : IFFShipmentSelected.iffMasterId}});
  }

  OnDelinquencyReportSelected() {
    this.router.navigate(['/', 'frtDelinquency']);
  }
  OnFrtComprehensiveReportSelected() {
    this.router.navigate(['/', 'frtComprehensiveReport']);
  }

  getFRTIffShipmentDetailsColumnDefs(): (ColDef | ColGroupDef)[] {
    return [
      <ColDef>
      {
        headerName: 'SCAC Code',
        field: 'scac'
      },
      {
        headerName: 'SCAC ',
        field: 'scacName'
      },
      {
        headerName: 'Agency Bureau Name',
        field: 'agencyBureauName'
      },
      {
        headerName: 'Pro Bill Number',
        field: 'proBillNumber'
      },
      {
        headerName: 'BOL',
        field: 'bolNumber'
      },
      {
        headerName: 'Invoice',
        field: 'invoiceNumber'
      },
      {
        headerName: 'Pickup Date',
        field: 'pickupDate'
      },
      {
        headerName: 'Date Paid By Agency',
        field: 'datePaidByAgency'
      },
      {
        headerName: 'Shipping',
        field: 'shippingSystem'
      },
      {
        headerName: 'Line Haul Cost',
        field: 'lineHaulCost',
        valueFormatter: this.iffShipmentSummaryService.formatNumber
      },
      {
        headerName: 'Total Accessorial Cost',
        field: 'totalAccessorialCost',
        valueFormatter: this.iffShipmentSummaryService.formatNumber
      },
      {
        headerName: 'Fuel Sur charge Received',
        field: 'fuelSurChargeReceived',
        valueFormatter: this.iffShipmentSummaryService.formatNumber
      },
      {
        headerName: 'Fuel Sur charge Completed',
        field: 'fuelSurChargeCompleted',
        valueFormatter: this.iffShipmentSummaryService.formatNumber
      },
      {
        headerName: 'Amount Subject To IFF Received',
        field: 'amountSubjectToIFFReceived',
        valueFormatter: this.iffShipmentSummaryService.formatNumber
      },
      {
        headerName: 'Amount Subject To IFF Completed',
        field: 'amountSubjectToIFFCompleted',
        valueFormatter: this.iffShipmentSummaryService.formatNumber
      },
      {
        headerName: 'IFF AmountDue Received',
        field: 'iffAmountDueReceived',
        valueFormatter: this.iffShipmentSummaryService.formatNumber
      },
      {
        headerName: 'IFF AmountDue Completed',
        field: 'iffAmountDueCompleted',
        valueFormatter: this.iffShipmentSummaryService.formatNumber
      },
      {
        headerName: 'Payment System',
        field: 'paymentSystem'
      },
      {
        headerName: 'Type Of Payment',
        field: 'typeOfPayment'
      },
      {
        headerName: 'Payment Date',
        field: 'paymentDate'
      },
      {
        headerName: 'Payment Ref Number',
        field: 'paymentRefNumber'
      },
      {
        headerName: 'Validation Status',
        field: 'validationStatus'
      },
      {
        headerName: 'Failure Reason',
        field: 'failureReason'
      }
    ];
  }
}
